
/**
 * Support API
 */
export default class Support {
  constructor(axios) {
    this.$axios = axios
  }

  ContactUs(message, recaptcha = '') {
    return new Promise((resolve, reject) => {
      this.$axios({
        method: 'post',
        url: '/support/contact',
        data: { message, recaptcha }
      })
        .then(() => {
          resolve()
        })
        .catch((err) => {
          if(err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            reject(err.response.data.error.message)
            return
          }

          reject(err.message)
        })
    })
  }
}
